export default {
  props: {
    styleObj: {
      type: Object,
      default() {
        return {};
      }
    },
    themeColor: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      list: [{
        name: '意外身故',
        value: '30万',
        info: ''
      }, {
        name: '意外伤残',
        value: '20万',
        info: '权益说明：权益说明',
        isClick: false
      }, {
        name: '意外伤残',
        value: '20万',
        info: '22',
        isClick: false
      }],
      tabIndex: 0
    };
  },
  methods: {
    infoClickFun(index) {
      console.log(222);
      this.list[index].isClick = !this.list[index].isClick;
    }
  }
};